import React, { Fragment, useEffect, useState } from "react";
import { Card, CardBody, Col, Container, FormGroup, Row, Form, Input, Popover, PopoverBody, PopoverHeader } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { DateRangePicker } from "rsuite";
import moment from "moment";
import { useHistory, Link } from "react-router-dom";
import Select from "react-select";
import Breadcrumbs from "../../../layout/breadcrumb";
import DatePicker from "../../../share-components/ui/DateRangePicker";
import CommonDataTable from "../../../share-components/table/commonDataTable";
import withReducer from "../../../store/withReducer";
import orderReducer from "../store";
import { getGojungoOrders, getGojungoSettings, setGojungoSettings } from "../store/orderSlice";
import PreLoader from "../../../share-components/ui/preLoader";
import BackInStockTable from "../../backInStock/content/backInStockTable";

const { afterToday } = DateRangePicker;

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: 50,
    border: "none",
  }),
};

function GojungoOrders() {
  const history = useHistory();
  const dispatch = useDispatch();
  const TodayDate = new Date();
  const sevenDays = new Date().setDate(TodayDate.getDate() - 90);
  const [dateRange, setDateRange] = useState([sevenDays, TodayDate]);
  const [orderCheckBoxData, setOrderCheckBoxData] = useState({ idArray: [] });
  const [timer, setTimer] = useState(null);
  const [order, seOrder] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [startDate, endDate] = dateRange;
  const [channel, setChannel] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [currency, setCurrency] = useState(null);
  const [shipCountry, setShipCountry] = useState(null);
  const [sku, setSku] = useState(null);
  const orderState = useSelector(({ order }) => order.order);

  useEffect(() => {
    dispatch(getGojungoSettings()).then((res) => dispatch(setGojungoSettings(res.payload)));
  }, [dispatch]);

  useEffect(() => {
    getData();
  }, [dispatch, startDate, endDate, page, pageSize, order, channel, tenant, currency, shipCountry, sku]);

  const getData = () => {
    setLoading(true);
    const data = {
      page: page,
      pageSize: pageSize,
      start_date: moment(startDate).format("YYYY-MM-DD"),
      end_date: moment(endDate).format("YYYY-MM-DD"),
      ...{ order: order ? order : null },
      ...{ channel: channel ? channel.id : null },
      ...{ tenant: tenant ? tenant.id : null },
      ...{ currency: currency ? currency.id : null },
      ...{ shipCountry: shipCountry ? shipCountry.id : null },
      ...{ sku: sku ? sku : null },
    };
    dispatch(getGojungoOrders(data)).then((res) => {
      setLoading(false);
    });
  };

  const dataMenu = [
    {
      type: 0,
      text: "Gojungo Orders",
    },
  ];

  const tableColumns = [
    {
      name: "Order ID",
      selector: (row) => row.gojungo_id,
      sortable: true,
      center: false,
    },
    {
      name: "Channel",
      selector: (row) => row.channel.toUpperCase(),
      sortable: true,
      center: false,
    },
    {
      name: "Tenant",
      selector: (row) => row.tenant.toUpperCase(),
      sortable: true,
      center: false,
    },
    {
      name: "Order Date",
      selector: (row) => row.order_date,
      sortable: true,
      center: false,
    },
    {
      name: "Currency",
      selector: (row) => row.currency,
      sortable: true,
      center: false,
    },
    {
      name: "Price",
      selector: (row) => row.total_price,
      sortable: true,
      center: false,
    },
    {
      name: "Ship Country Code",
      selector: (row) => row.ship_country_code,
      sortable: true,
      center: false,
    },
    {
      name: "Fulfillment Status",
      selector: (row) => row.fulfillment,
      sortable: true,
      center: false,
    },
    {
      name: "Action",
      center: true,
      width: "100px",
      cell: (row) => (
        <button
          className="btn btn-sm btn-primary"
          style={{ whiteSpace: 'nowrap' }}
          onClick={() => history.push(`${process.env.PUBLIC_URL}/order/gojungo-orders/${row.id}`)}
        >
          View
        </button>
      ),
    },
  ];

  const ExpandedComponent = ({ data }) => {
    const childData = data.items;

    const childTableColumns = [
      {
        name: "SKU",
        selector: (row) => row.sku ?? <p style={{ color: "red", fontWeight: 500 }}>Not Found</p>,
        sortable: true,
        center: false,
      },
      {
        name: "Gojungo SKU",
        selector: (row) => row.gojungo_sku,
        sortable: true,
        center: false,
        width: '200px'
      },
      {
        name: "Quantity",
        selector: (row) => row.quantity,
        sortable: true,
        center: false,
      },
      {
        name: "Price",
        selector: (row) => row.price,
        sortable: true,
        center: false,
      },
      {
        name: "Discount",
        selector: (row) => row.total_discount,
        sortable: true,
        center: false,
      },
      {
        name: "Is Return",
        selector: (row) => (row.is_return ? "Yes" : "No"),
        sortable: true,
        center: false,
      },
      {
        name: "Is Cancelled",
        selector: (row) => (row.is_cancelled ? "Yes" : "No"),
        sortable: true,
        center: false,
      },
    ];

    return (
      <div className="px-5 pt-3 pb-5 border-bottom">
        <CommonDataTable headerColumns={childTableColumns} data={childData} noAction pagination={false} />
      </div>
    );
  };

  return (
    <Fragment>
      <Breadcrumbs title="Gojungo Orders" data={dataMenu} />

      <Container fluid={true} className="product-wrapper">
        <div className="product-grid">
          <div className="feature-products">
            <Row className="mb-2">
              <Col sm="2">
                <div className="dashboard-datepicker">
                  <DatePicker
                    dateRange={dateRange}
                    dateRangeChange={(date) => {
                      setDateRange(date);
                    }}
                    defaultValue={[TodayDate, sevenDays]}
                    disabledDate={afterToday()}
                    paddingLeft={10}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <FormGroup>
                  <Select
                    placeholder={<div>Channel</div>}
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.id}
                    className="select2-filter"
                    isClearable
                    cacheOptions
                    styles={customStyles}
                    options={orderState.gojungoSettings.channels}
                    onChange={(e) => {
                      setChannel(e ? e : null);
                    }}
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md={2}>
                <FormGroup>
                  <Select
                    placeholder={<div>Tenats</div>}
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.id}
                    className="select2-filter"
                    isClearable
                    cacheOptions
                    styles={customStyles}
                    options={orderState.gojungoSettings.tenants}
                    onChange={(e) => {
                      setTenant(e ? e : null);
                    }}
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md={2}>
                <FormGroup>
                  <Select
                    placeholder={<div>Currency</div>}
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.id}
                    className="select2-filter"
                    isClearable
                    cacheOptions
                    styles={customStyles}
                    options={orderState.gojungoSettings.currency}
                    onChange={(e) => {
                      setCurrency(e ? e : null);
                    }}
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md={2}>
                <FormGroup>
                  <Select
                    placeholder={<div>Ship Country Code</div>}
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.id}
                    className="select2-filter"
                    isClearable
                    cacheOptions
                    styles={customStyles}
                    options={orderState.gojungoSettings.shipCountries}
                    onChange={(e) => {
                      setShipCountry(e ? e : null);
                    }}
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                  />
                </FormGroup>
              </Col>
              <Col sm="2">
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                  }}
                >
                  <FormGroup className="m-0">
                    <Input
                      name="search"
                      type="text"
                      className="form-control"
                      onChange={(e) => {
                        clearTimeout(timer);
                        const newTimer = setTimeout(() => {
                          seOrder(e.target.value);
                        }, 500);
                        setTimer(newTimer);
                      }}
                      placeholder="Search Order Code"
                    />
                    <i className="fa fa-search"></i>
                  </FormGroup>
                </Form>
              </Col>
              <Col sm="2">
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                  }}
                >
                  <FormGroup className="m-0">
                    <Input
                      name="search"
                      type="text"
                      className="form-control"
                      onChange={(e) => {
                        clearTimeout(timer);
                        const newTimer = setTimeout(() => {
                          setSku(e.target.value);
                        }, 500);
                        setTimer(newTimer);
                      }}
                      placeholder="Search SKU"
                    />
                    <i className="fa fa-search"></i>
                  </FormGroup>
                </Form>
              </Col>
            </Row>

            <Row>
              <Col sm="12" className="mt-3">
                <Card>
                  <CardBody>
                    {loading ? (
                      <div style={{ minHeight: 400 }}>
                        <PreLoader />
                      </div>
                    ) : (
                      <div className="table-responsive product-table">
                        <BackInStockTable
                          paginationTotalRows={orderState.gojungoTableRow}
                          idArray={orderCheckBoxData}
                          selectableRows={false}
                          tableColumns={tableColumns}
                          backStockData={orderState.gojungoData || []}
                          backInRequestState={orderState}
                          pageChange={(page) => setPage(page)}
                          onPageSizeChange={(pageSize) => setPageSize(pageSize)}
                          paginationRowsPerPageOptions={[10, 25, 50, 100]}
                          paginationDefaultPage={page}
                          paginationPerPage={pageSize}
                          expandableRows
                          expandableRowsComponent={ExpandedComponent}
                          progressPending={loading}
                        />
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      </Container>
    </Fragment>
  );
}

export default withReducer([{ order: orderReducer }])(GojungoOrders);
